import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { XSRF_COOKIE_NAME } from "api-v2";
import { getCookie } from "utils/cookiesHelper";
import { isDev } from "utils/logging";

// Reverb speaks the Pusher protocol, so the pusher-js client is required by
// laravel-echo even though the broadcaster below is "reverb".
window.Pusher = Pusher;

const REVERB_KEY = process.env.REACT_APP_PUSHER_APP_KEY;
const REVERB_HOST = process.env.REACT_APP_PUSHER_HOST;
const REVERB_PORT = Number(process.env.REACT_APP_PUSHER_PORT) || 443;
const REVERB_SCHEME = process.env.REACT_APP_PUSHER_SCHEME ?? "https";
const API_URL = process.env.REACT_APP_API_BASE_URL;

const getAuthToken = (): string => (getCookie(XSRF_COOKIE_NAME) as string) ?? "";

// AC1: null-safe — unconfigured (no key/host) or a failed init must never
// throw at import time or during use. Every caller already null-checks
// `echo` (see useUserNotifications.ts).
const createEcho = (): Echo<"reverb"> | null => {
	if (!REVERB_KEY || !REVERB_HOST || !API_URL) {
		return null;
	}

	try {
		return new Echo({
			broadcaster: "reverb",
			key: REVERB_KEY,
			wsHost: REVERB_HOST,
			wsPort: REVERB_PORT,
			wssPort: REVERB_PORT,
			forceTLS: REVERB_SCHEME === "https",
			enabledTransports: ["ws", "wss"],
			authEndpoint: `${API_URL}broadcasting/auth`,
			auth: {
				headers: {
					"X-XSRF-TOKEN": getAuthToken(),
				},
			},
		});
	} catch (error) {
		if (isDev()) {
			// eslint-disable-next-line no-console
			console.error("[Reverb] failed to initialise Echo", error);
		}
		return null;
	}
};

const echo = createEcho();

export { echo };
